import { AppDispatch } from '../../app/store';
import { showErrorSnackbar, showSuccessSnackbar } from '../../component/snackbar/Snackbar.slice';
import { Messages } from '../../Constants/Messages';
import { fetchNotificationsByJobid, setNewNotification } from '../Slices/Notifications.slice';
import { FileComparisonNotification, FileComparisonSaveStatus } from '../Types/Notifications.types';
import { TestCaseStatus } from '../Types/SanityCheck.types';
import { setTestCaseStatus } from '../Slices/SanityCheck.slice';
import { setIsTestCaseRunInProgress } from '../../component/TopMenu/CalculationRun.slice';

export function addFileComparisonSuccessNotification(
    message: FileComparisonNotification,
    dispatch: AppDispatch,
) {
    dispatch(fetchNotificationsByJobid(message.groupId));
    if (message.fileComparisonSaveStatus === FileComparisonSaveStatus.Passed) {
        dispatch(setTestCaseStatus(TestCaseStatus.Passed));
    }
    else if (message.fileComparisonSaveStatus === FileComparisonSaveStatus.Failed) {
        dispatch(setTestCaseStatus(TestCaseStatus.FailedMismatch));
    }
    else if (message.fileComparisonSaveStatus === FileComparisonSaveStatus.FailedDueToError) {
        dispatch(setTestCaseStatus(TestCaseStatus.Error));
    }
    else {
        dispatch(setTestCaseStatus(TestCaseStatus.Error));
    }
    showSuccessSnackbar(dispatch, Messages.FILE_MATCH_SUCCESS);
    dispatch(setNewNotification());
    dispatch(setIsTestCaseRunInProgress(false));
}

export function addFileComparisonFailureNotification(
    message: FileComparisonNotification,
    dispatch: AppDispatch,
) {
    dispatch(setTestCaseStatus(TestCaseStatus.FailedMismatch));
    dispatch(fetchNotificationsByJobid(message.groupId));
    showErrorSnackbar(dispatch, Messages.FILE_MATCH_FAILURE);
    dispatch(setNewNotification());
    dispatch(setIsTestCaseRunInProgress(false));
}